<template>
    <div id='company-user'>
        <el-dialog title="选择负责人" :visible.sync="dialogVisible"  :close-on-click-modal="false" @close="cancelDialog" class="dialog-large" width="50%">
            <div class="company-user-header">
                <el-select v-model="deptId" :placeholder="$STR('ws_label_add_warehouse_select_department', '选择部门')" style="margin-right: 10px" clearable>
                    <el-option
                        v-for="item in departmentList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="roleId" :placeholder="$STR('ws_label_add_warehouse_select_role', '选择角色')" style="margin-right: 10px" clearable>
                    <el-option
                        v-for="item in roleList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-input clearable placeholder="请输入账号/姓名/手机/邮箱"  @keyup.enter.native="searchUserList" v-model="keyword" type="text" class="user-keyword">
                </el-input>
                <el-button type="primary" plain @click="searchUserList" style="margin-left: 10px">{{ $STR('COMMON.common.search', '查询') }}</el-button>
            </div>
            <el-table :data="master_user.data" highlight-current-row style="min-height: 200px">
                <el-table-column label="" width="30px">
                    <template slot-scope="scope">
                        <el-radio v-model="master" :label="scope.row">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column label="账号" :show-overflow-tooltip="true" prop="userName"></el-table-column>
                <el-table-column prop="nickName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="手机号码" :show-overflow-tooltip="true" prop="phone"></el-table-column>
                <el-table-column label="邮箱" :show-overflow-tooltip="true" prop="email"></el-table-column>
                <el-table-column label="所属角色" :show-overflow-tooltip="true" prop="role"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope"><span>{{scope.row.status==1?'正常':'停用'}}</span></template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDialog">{{$STR('COMMON.common.btn.cancel', '取消') }}</el-button>
                <el-button type="primary" plain @click="confirm">{{$STR('goods.SKUSet.list.confrim', '确认提交')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['visible', 'tenantId', 'orgId'],
    data() {
        return {
            master_user: {
                sel: null,
                columns: [
                    { field: 'nickName', title: '姓名', width: 300 },
                    { field: 'phone', title: '手机', width: 300 },
                    { field: 'email', title: '邮箱', width: 300 }
                ],
                data: []
            },
            count1: 0,
            count: 0,
            current: 1,
            rows: 10,
            order: 'createDate',
            asc: false,
            keyword: '',
            userParam: {
                nickName: '',
                phone: '',
                email: '',
                status: '0',
                tenantId: '',
                orgId: '',
                userName: '',
                password: ''
            },
            dialogVisible: false,
            master: {}, // 负责人
            userDetails: {},
            deptId: '', //部门id
            roleId: '', //角色id
            departmentList: [], //部门列表
            roleList: [] //角色列表
        };
    },
    activated () {
    },
    created() {
        this.userParam.tenantId = this.tenantId;
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.getDepartmentList();
                this.getRoleList();
                this.searchUserList();
            }
        }
    },
    methods: {
        // 确认选择负责人
        confirm () {
            this.$emit('confirm', this.master);
            this.dialogVisible = false;
            this.$emit('close');
        },
        getTemplateRow (val) {
            this.master = val;
        },
        close(userParam) {
            this.dialogVisible = false;
            this.$refs[userParam].resetFields();
        },
        searchUserList() {
            this.$http.get(WebApi.userManage.user, {
                params: {
                    current: this.current,
                    rows: this.rows,
                    order: this.order,
                    asc: this.asc,
                    keyword: this.keyword,
                    tenantId: this.tenantId,
                    orgId: this.orgId,
                    deptId: this.deptId,
                    roleId: this.roleId
                }
            }).then(response => {
                this.master_user.data = [];
                this.count = response.data.total;
                for (let item of response.data.rows) {
                    item.isSet = item.isSet;
                    if (item.roles.length > 0) {
                        var str = '';
                        for (let role of item.roles) {
                            str += role.name + ',';
                        }
                        str = str.substring(0, str.length - 1);
                        item.role = str;
                    } else {
                        item.role = '无';
                    }
                    if (item.id !== baseStore.getUserDetail().id) {
                        this.master_user.data.push(item);
                    } else {
                        this.count--;
                    }
                }
                console.log(this.master_user.data);
            });
        },
        handleSizeChange(val) {
            this.rows = val;
            this.searchUserList();
        },
        handleCurrentChange(val) {
            this.current = val;
            this.searchUserList();
        },
        cancelDialog() {
            this.dialogVisible = false;
            this.$emit('close');
        },
        //获取部门
        getDepartmentList() {
            var _self = this;
            _self.$http.get(WebApi.warehouse.department, {
                params: {
                    orgId: _self.orgId
                }
            }).then(_ => {
                _self.departmentList = _.data.data;
            });
        },
        //获取角色
        getRoleList() {
            this.$http.get(WebApi.warehouse.role, {
                params: {
                    orgId: this.orgId
                }
            }).then(_ => {
                let val = _.data;
                this.roleList = val;
            });
        }
    }
};
</script>
<style>
    #company-user .el-pagination{
        margin-top: 5px;
    }
    #company-user .company-user-header {
        width: 100%;
        display: flex;
        justify-content: flex-start;
    }
    #company-user .user-keyword{
        width: 338px;
        float: right;
    }
    #company-user .item{
        padding-bottom: 30px;
    }
    #company-user{
        position: relative;
    }
    #company-user .el-card{
        position: absolute;
        top: 20px;
        left: 20px;
        width: 95%;
    }
    #company-user .cell{
        text-align: center;
        font-size: 14px;
    }
    #company-user .el-table-add-row{
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        margin-top: 20px;
    }
    #company-user .text {
        font-size: 14px;
    }
    #company-user .el-card__body{
        padding-bottom: 20px;
    }
    /*#company-user .el-form-item{
        float: left;
        margin-left: 15px;
        margin-top: 10px;
        margin-right: 2%;
        width: 15%;
    }
    #company-user .el-form{
        padding-top: 40px;
        padding-bottom: 20px;
    }*/
    #company-user .add-user{
        float: right;
        margin-top: 10px;
        /*z-index: 10;*/
    }
    #company-user .add-user button {
        line-height: 30px;
        height: 36px;
        width: 80px;
        padding: 0;
    }
    #company-user .user-enable{
        margin-right: 0;
        width: 190px;
    }
    #company-user el-button--primary{
        padding: 0;
    }
    #company-user .el-form-item__error{
        padding-top: 1px;
    }
    #company-user .el-button+.el-button {
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/organization/manInCharge.vue